import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["scheduledAtField", "segmentsField"]

    connect() {
        // Initialize the form based on initial values
        this.toggleScheduledAt()
        this.toggleSegments()
    }

    toggleScheduledAt() {
        const scheduleRadio = this.element.querySelector('input[name="mailing[mailing_type]"][value="schedule"]')
        const onDemandRadio = this.element.querySelector('input[name="mailing[mailing_type]"][value="on-demand"]')

        if (scheduleRadio && scheduleRadio.checked) {
            // Show the scheduled_at field when "schedule" is selected
            this.scheduledAtFieldTarget.style.display = "block"
        } else {
            // Hide the scheduled_at field when "on-demand" is selected
            this.scheduledAtFieldTarget.style.display = "none"

            // Show confirmation alert when "on-demand" is selected
            if (onDemandRadio && onDemandRadio.checked) {
                // Only show the alert if this is a change (not on initial load)
                if (onDemandRadio.dataset.confirmed !== "true") {
                    const confirmed = confirm("WARNING: Once saved, this mailing will be sent immediately and cannot be undone. Are you sure you want to proceed?");
                    if (confirmed) {
                        onDemandRadio.dataset.confirmed = "true";
                    } else {
                        // If user cancels, switch back to schedule
                        scheduleRadio.checked = true;
                        this.scheduledAtFieldTarget.style.display = "block";
                    }
                }
            }
        }
    }

    toggleSegments() {
        const segmentsRadio = this.element.querySelector('input[name="deliver_to"][value="segments"]')

        if (segmentsRadio && segmentsRadio.checked) {
            // Show the segments field when "segments" is selected
            this.segmentsFieldTarget.style.display = "block"
        } else {
            // Hide the segments field when "all_members" is selected
            this.segmentsFieldTarget.style.display = "none"
        }
    }
}
